<section #containerHome id="containerHome" class="section home active">

  <div class="wrapper-home-panel">

    <div class="home-info">
      <h3 data-translate="HOME.TITLE1"></h3>
      <h1>Marc Wieland</h1>
      <h3>
        <span data-translate="HOME.TITLE2_PART1"></span>
        <span class="highlight" data-translate="HOME.ROLE.DEVELOPER"></span>
        <span data-translate="HOME.TITLE2_PART2"></span>
        <span class="highlight" data-translate="HOME.ROLE.CONSULTANT"></span>.
      </h3>
      <p class="desc" data-translate="HOME.DESCRIPTION"></p>
      <div class="btn-sci">
        <a href="/cv/cv_wieland.pdf" download="cv_wieland.pdf" class="btn" data-translate="HOME.CV_BTN"></a>
        <div class="sci">
          <a href="https://linkedin.com/in/marc-wieland-a49473151" target="_blank">
            <i class='bx bxl-linkedin'></i>
            <span class="tooltip">Linkedin</span>
          </a>
          <a href="https://x.com/mrcinexery" target="_blank">
            <i class='bx bxl-twitter'></i>
            <span class="tooltip">Twitter</span>
          </a>
        </div>
      </div>
    </div>

    <div class="home-img">
      <img [src]="delayedImageSrc">
    </div>

  </div>

  <app-footer (toggleImprint)="toggleImprint.emit()" (togglePrivacy)="togglePrivacy.emit()"
    [imprintBusy]="imprintBusy"></app-footer>
</section>
